import React, {useEffect, useState} from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import Fade from '@mui/material/Fade';
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import FormControl from "@mui/material/FormControl";
import RadioGroup from "@mui/material/RadioGroup";
import {DatePicker, Select} from "antd";
import axios from "axios";
import {toast} from "react-toastify";
import {API_PATH} from "../../components/const";
import dayjs from "dayjs";

const EmployeFilter = (props) => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [offices, setOffices] = useState([])
    const [departments, setDepartments] = useState([])
    const [time, setTime] = useState(new Date());
    const [parents, setParents] = useState([])

    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const getDeps = (val) => {
        axios.get(API_PATH + "company/" + localStorage.getItem('id') + "/hr/department/all" + (val?.length > 0 ? "?search_str=" + val : ""), {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setDepartments(res?.data?.items)
            })
            .catch(err => {
                toast.error("Ошибка")
            })
    }
    const getBuilding = (val) => {
        axios.get(API_PATH + "company/" + localStorage.getItem('id') + "/branch/branch/all?hierarchy=3" + (val > 0 ? "&parent_id=" + val : ""), {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setOffices(res?.data)
            })
            .catch(err => {
                toast.error("Ошибка")
            })
    }
    const addFilterClear = () => {
        props.setbuilding_id("")
        props.setdepartment_id("")
        props.setAge("")
        props.setPosition("")
        props.setGender("")
        props.getUsers()
    }
    const addFilter = () => {
        axios.get(API_PATH + "user/company/" + localStorage.getItem('id') + "/user/all" + (props.building_id ? "?building_id=" + props.building_id + "&" : "?") + (props.department_id ? "department_id=" + props.department_id : "") + (props.gender ? "&gender=" + props.gender  : "") + (props.position ? "&position=" + props.position : "") + (props.age ? "&dob=" + props.age  : ""), {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                props.setUsers(res.data?.items)
                props.setUsersObj(res.data)
                setAnchorEl(null);
            })
            .catch(err => {
                toast.error("Ошибка")
            })
    }
    const searchEmploye = (e) => {
        axios.get(API_PATH + "user/company/" + localStorage.getItem('id') + "/user/all" + (e?.length > 0 ? "?search_str=" + e : ""), {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                props.setUsers(res.data?.items)
            })
            .catch(err => {
                toast.error("Ошибка")
            })
    }
    function onChange(date, dateString) {

        if (dateString[0] !== "" && dateString[1] !== "") {
            // axios.get(API_PATH + "company/" + localStorage.getItem('id') + "/analitics/visit/time/statistics?start_date_str=" + dateString[0] + "&end_date_str=" + dateString[1], {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            //     .then(res => {
            //
            //     })

        } else {

        }
    }
    const getParentBuilding = (val) => {
        axios.get(API_PATH + "company/" + localStorage.getItem('id') + "/branch/sections/all" + (val?.length > 0 ? "?search_str=" + val : ""), {headers: {"Authorization": 			"Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setParents(res?.data)
            })
            .catch(err => {
                toast.error("Ошибка")
            })
    }
    useEffect(() => {
        getBuilding()
        getParentBuilding()
        getDeps()
    }, []);
    return (
        <div className="search-top">
            <div className="d-flex align-items-center">
                <div className="search-item w-100">
                    <label htmlFor="searchItem"><img src="/icon/Icon62.svg" alt="loupe"/></label>
                    <input type="text" placeholder="Искать в админке" onChange={(e) => searchEmploye(e.target.value)}
                           id="searchItem"/>
                </div>

                <div className="ml-16 mr-16">
                    <DatePicker onChange={onChange}
                                style={{width: "170px"}}
                                placeholder="Выберите дату"
                                defaultValue={dayjs(time)}

                    />
                </div>
                <Button
                    id="fade-button"
                    aria-controls={open ? 'fade-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? 'true' : undefined}
                    onClick={handleClick}
                    className="filter-btn"
                >
                    <img src="/icon/filtr2.svg" alt="filter"/> Фильтр

                </Button>
            </div>
            <Menu
                id="fade-menu"
                MenuListProps={{
                    'aria-labelledby': 'fade-button',
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                TransitionComponent={Fade}
            >
                <div className=" left-fl-big">
                    <div className="d-flex">
                        <div className="left-fl-pair">
                            <div className="inputs-box">
                                <label className="font-family-medium">Дата рождения </label>
                                <input
                                    value={props.age}
                                    type="date" onChange={(e) => props.setAge(e.target.value)}/>
                            </div>
                            <div className="inputs-box">
                                <label className="font-family-medium">Должность </label>
                                <input type="text"
                                       value={props.position}
                                       onChange={(e) => props.setPosition(e.target.value)}/>
                            </div>
                            <div className="inputs-box">
                                <label className="font-family-medium">Пол </label>
                                <FormControl>
                                    <RadioGroup
                                        row
                                        value={props.gender}
                                        onChange={(e) => props.setGender(e.target.value)}
                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                        name="row-radio-buttons-group"
                                    >
                                        <FormControlLabel value="male" control={<Radio/>} label="Мужской"/>
                                        <FormControlLabel value="female" control={<Radio/>} label="Женский"/>
                                    </RadioGroup>
                                </FormControl>
                            </div>
                        </div>
                        <div className="left-fl-pair">
                            <div className="inputs-box">
                                <label className="font-family-medium">Отделы</label>
                                {/*<Select*/}
                                {/*    className="w-100"*/}
                                {/*    onChange={(e) => setdepartment_id(e)}*/}
                                {/*>*/}
                                {/*    <option value="">Все</option>*/}
                                {/*    {*/}
                                {/*        departments?.map((item, index) => (*/}
                                {/*            <option value={item?.id} key={index}>{item?.department_title}</option>*/}
                                {/*        ))*/}
                                {/*    }*/}
                                {/*</Select>*/}
                                <Select
                                    showSearch
                                    placeholder="Поиск, чтобы выбрать"
                                    optionFilterProp="children"
                                    className="w-100"
                                    onSearch={getDeps}
                                    value={props.department_id}
                                    onChange={(e) => props.setdepartment_id(e)}
                                    filterOption={(input, option) => (option?.label ?? '').includes(input)}
                                    filterSort={(optionA, optionB) =>
                                        (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                                    }
                                    options={departments?.map((item) => {
                                        return {
                                            value: item.id,
                                            label:
                                            item?.department_title
                                        };
                                    })}
                                />


                            </div>
                            <div className="inputs-box">
                                <label className="font-family-medium">Раздел</label>
                                <Select
                                    showSearch
                                    optionFilterProp="children"
                                    className="w-100"
                                    placeholder="Выберите pаздел"

                                    onSearch={getParentBuilding}
                                    onChange={(e) => {
                                        getBuilding(e)
                                        props.setparents_id(e)
                                    }}
                                    value={props.parents_id}
                                    filterOption={(input, option) => (option?.label ?? '').includes(input)}
                                    filterSort={(optionA, optionB) =>
                                        (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                                    }
                                    options={parents?.map((item) => {
                                        return {
                                            value: item.id,
                                            label:
                                            item?.branch_title
                                        };
                                    })}
                                />


                            </div>
                            <div className="inputs-box">
                                <label className="font-family-medium">Филиалы</label>
                                <Select
                                    showSearch
                                    placeholder="Выберите филиал"
                                    optionFilterProp="children"
                                    className="w-100"
                                    // onSearch={getBuilding}
                                    value={props.building_id}
                                    onChange={(e) => props.setbuilding_id(e)}
                                    filterOption={(input, option) => (option?.label ?? '').includes(input)}
                                    filterSort={(optionA, optionB) =>
                                        (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                                    }
                                    options={offices?.map((item) => {
                                        return {
                                            value: item.building_id,
                                            label:
                                            item?.branch_title
                                        };
                                    })}
                                />


                            </div>
                        </div>
                    </div>
                    <div className="d-flex">
                        <button className="font-family-medium clear-filter" onClick={addFilterClear}>
                           <span>Очистить</span>
                        </button>
                        <div className="con-btn">

                            <button className="font-family-medium" onClick={addFilter}>
                                <img src="/icon/bird.svg" className="mr-8"/><span>Применить фильтры</span>
                            </button>
                            <button className="font-family-medium ml-8" onClick={handleClose}>Отменить</button>
                        </div>
                    </div>
                </div>
            </Menu>
        </div>
    );
};

export default EmployeFilter;